export const PHOTOS = {
  meetSusan: "/images/meet-susan.png",
  podcastCover: "/images/podcast-cover.jpg",
  hero: "/images/IMG_1119.jpg",
  bio: "/images/IMG_1127.jpg",
  holdingBook: "/images/IMG_1125.jpg",
  drewSet: "/images/drew-set-collage.jpg",
  coverStar: "/images/IMG_1124.jpg",
  drewNyc: "/images/IMG_2442.jpg",
  nycMemorial: "/images/nyc-memorial.jpg",
  standing: "/images/IMG_2787.jpg",
  headshot: "/images/headshot-pink.jpg",
  withValerie: "/images/with-valerie-bertinelli.jpg",
  bookCover: "/images/book-infinite-life-mockup.png",
  pressHatSeated: "/images/press-hat-seated.jpg",
  pressHatPalm: "/images/press-hat-palm.jpg",
  pressGoopStage: "/images/press-goop-stage.jpg",
  pressSigningFlowers: "/images/press-signing-flowers.jpg",
  pressSigningReader: "/images/press-signing-reader.jpg",
  pressFloralDress: "/images/press-floral-dress.jpg",
  pressWhiteJacket: "/images/press-white-jacket.jpg",
  pressWithDog: "/images/press-with-dog.jpg",
  orbs: "https://images.pexels.com/photos/9446126/pexels-photo-9446126.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  podcast: "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBwb2RjYXN0JTIwc3R1ZGlvJTIwbWljcm9waG9uZSUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3ODczNjYzOTZ8MA&ixlib=rb-4.1.0&q=85",
};

export const SOCIALS = {
  instagram: "https://www.instagram.com/susangrauofficial",
  facebook: "https://www.facebook.com/susangrauofficial",
  tiktok: "https://www.tiktok.com/@susangrauofficial",
  youtube: "https://youtube.com/@susangrauofficial",
  threads: "https://www.threads.com/@susangrauofficial",
  reels: [
    "https://www.instagram.com/reel/DRLSeO2gS41/",
    "https://www.instagram.com/reel/DVjz2gLEii1/",
  ],
};

export const LINKS = {
  mainSite: "https://www.susangrau.com",
  pressSite: "https://www.susangraupress.com",
  app: "https://www.myinfinite.app",
  amazon: "https://www.amazon.com/dp/1401977235",
  kindle: "https://www.amazon.com/Infinite-Life-Lessons-Wisdom-Between-ebook/dp/B0CL5WHPGV",
  barnesNoble: "https://www.barnesandnoble.com/w/infinite-life-infinite-lessons-susan-grau/1144231811",
  waterstones: "https://www.waterstones.com/book/infinite-life-infinite-lessons/susan-grau/9781401977238",
  indigo: "https://www.indigo.ca/en-ca/infinite-life-infinite-lessons-wisdom-from-the-spirit-world-on-living-dying-and-the-in-between/9781401977238.html",
  booktopia: "https://www.booktopia.com.au/infinite-life-infinite-lessons-susan-grau/book/9781401977238.html",
  booksAMillion: "https://www.booksamillion.com/p/Infinite-Life-Lessons/Susan-Grau/9781401977238?id=9115763858270",
};

export const PODCAST = {
  apple: "https://podcasts.apple.com/us/podcast/infinite-life-infinite-wisdom/id1746812846",
  spotify: "https://open.spotify.com/show/74lUNuFpp1csmAthYuHdQS",
  appleEmbed: "https://embed.podcasts.apple.com/us/podcast/infinite-life-infinite-wisdom/id1746812846",
  spotifyEmbed: "https://open.spotify.com/embed/show/74lUNuFpp1csmAthYuHdQS?utm_source=generator&theme=0",
};

export const CONTACT = {
  name: "Meghan Amaral",
  role: "CEO of M Media Corp",
  role2: "Talent Manager",
  phone: "+1 (949) 735-3732",
  email: "meghan@mmediacorp.com",
};
